<template>
  <div>
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="24">
        <el-col :span="6">
          <el-input placeholder="请输入姓名或手机号" v-model="queryInfo.cite" clearable @clear="getUserList"></el-input>
        </el-col>
        <el-col :span="3">
          <el-button type="success" icon="el-icon-search" @click="getUserList">搜索</el-button>
        </el-col>
        <el-col :span="6">
          <el-radio-group v-model="queryInfo.status" @change="getUserList">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button :label="1">正常</el-radio-button>
            <el-radio-button :label="9">冻结</el-radio-button>
            <el-radio-button :label="0">删除</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>

      <!-- 用户列表区域 -->
      <el-table :data="tableData" stripe>
        <el-table-column prop="id" v-if="hide"></el-table-column>
        <el-table-column type="index" label="序号" min-width="80"></el-table-column>
        <el-table-column label="姓名" prop="name" min-width="100"></el-table-column>
        <el-table-column label="手机号" prop="phoneno" min-width="125"></el-table-column>
        <el-table-column label="名片数量" prop="vcard_count" min-width="80"></el-table-column>
        <el-table-column label="注册时间" min-width="150">
          <template slot-scope="scope">
            <span>{{scope.row.create_dt | formatDate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="80">
          <template slot-scope="scope">
            <span :style="scope.row.status == '正常'?'color:#6FC334':(scope.row.status == '冻结'?'color:#FF9901':'color:#EB5753')">{{scope.row.status}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="scope">
            <div>
              <el-button-group>
                <el-button size="medium" type="warning" :disabled="scope.row.status=='删除' ? true : false" @click="showEditDialog(scope.row)">修改</el-button>
                <el-button size="medium" type="danger" :disabled="scope.row.status=='删除' ? true : false" @click="removeUserById(scope.row.id)">删除</el-button>
              </el-button-group>
              <el-button-group style="margin-left:10px;">
                <el-button size="medium" @click="cardRout('card',scope.row.phoneno)">名片</el-button>
              </el-button-group>
            </div>
            <div>
              <el-button-group style="margin-top:10px;">
                <el-button size="medium" @click="cardRout('educationTraining',scope.row.phoneno)">学历培训</el-button>
                <el-button size="medium" @click="cardRout('workExperience', scope.row.phoneno)">工作经历</el-button>
              </el-button-group>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <div style="text-align: right">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.page_ix" :page-size="queryInfo.page_size" layout="prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog :title="formTitle" :visible.sync="dialogFormVisible" width="50%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="userForm" :rules="userFormRules" ref="userForm" label-width="70px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="userForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneno">
          <el-input v-model="userForm.phoneno"></el-input>
        </el-form-item>
        <el-form-item label="用户状态">
          <el-radio-group v-model="userForm.status">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="9">冻结</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('userForm',add_edit)">保存设置</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import formatDate from '../../utils/date'

export default {
  data() {
    // 验证手机号的规则
    var checkMobile = (rule, value, cb) => {
      // 验证手机号的正则表达式
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/

      if (regMobile.test(value)) {
        return cb()
      }

      cb(new Error('请输入合法的手机号'))
    }

    return {
      hide: false,
      type: '',
      formTitle: '',
      add_edit: '',
      // 获取用户列表的参数对象
      queryInfo: {
        status: 1,
        cite: '',
        // 当前的页数
        page_ix: 1,
        // 当前每页显示多少条数据
        page_size: 10
      },
      tableData: [],
      total: 0, // 分页总数
      // 控制添加用户对话框的显示与隐藏
      dialogFormVisible: false,
      // 用户的表单数据
      userForm: {
        name: '',
        phoneno: '',
        status: ''
      },
      // 添加表单的验证规则对象
      userFormRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phoneno: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getUserList()
  },
  methods: {
    async getUserList() {
      this.$axios.post('/admin/User/queryUser', this.queryInfo).then(res => {
        if (res.data.rst == 0) {
          this.tableData = res.data.data.data
          this.total = res.data.data.total
          this.tableData.forEach(e => {
            let std = e.status == '1' ? '正常' : (e.status == '9' ? '冻结' : '删除')
            e.status = std
          })
        } else {
          this.alertError(res.data.msg)
        }
      }).catch(err => {
        console.error('错误：', err)
      })
    },
    // 监听 page_size 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.page_size = newSize
      this.getUserList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      // console.log(newPage)
      this.queryInfo.page_ix = newPage
      this.getUserList()
    },
    // 监听用户对话框的关闭事件
    addDialogClosed(e) {
      this.$refs.userForm.resetFields()
    },
    // 展示编辑用户的对话框
    showEditDialog(row) {
      this.formTitle = '用户信息'
      this.add_edit = 'edit'
      this.dialogFormVisible = true
      let std = row.status == '正常' ? 1 : 9
      Object.assign(this.userForm, row)
      this.userForm.status = std
    },
    // 提交表单
    submitForm(formName, type) {
      // // 开启登录加载动画
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (type == 'edit') {
            // let sta = this.userForm.status == '正常' ? 1 : 9
            let _data = {
              user_id: this.userForm.id,
              status: this.userForm.status,
              name: this.userForm.name,
              phoneno: this.userForm.phoneno
            }
            this.$axios.post('/admin/User/saveUser', _data).then(res => {
              if (res.data.rst == 0) {
                this.alertSuccess(res.data.msg)
                this.getUserList()
                this.dialogFormVisible = false
              } else {
                this.alertError(res.data.msg)
              }
            }).catch(err => {
              console.error('错误：', err)
            })
          }
        } else {
          return false
        }
      })
    },
    // 根据Id删除对应的用户信息
    async removeUserById(id) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将删除所选内容, 是否继续?',
        '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)

      // 如果用户确认删除，则返回值为字符串 confirm
      // 如果用户取消了删除，则返回值为字符串 cancel
      // console.log(confirmResult)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      this.queryInfo.status = '0'
      let editparams = {
        user_id: id,
        status: this.queryInfo.status
      }
      this.$axios.post('/admin/User/saveUser', editparams).then(res => {
        if (res.data.rst == 0) {
          this.alertSuccess(res.data.msg)
          this.getUserList()
        } else {
          this.alertError(res.data.msg)
        }
      }).catch(err => {
        console.error('错误：', err)
      })
    },
    // 名片跳转
    cardRout(route_name, phone) {
      this.$router.push({ name: route_name, query: { phone: phone } })
    },
    // 成功弹窗
    alertSuccess(msg) {
      this.$message.success({
        showClose: true,
        duration: 1000,
        message: msg,
        type: 'success'
      })
    },
    // 错误消息
    alertError(msg) {
      this.$message.error({
        duration: 1000,
        showClose: true,
        message: msg,
        type: 'error'
      })
    }
  }

}
</script>

<style lang="less" scoped>

</style>
